var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThreeDots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1317_4250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.28271 12.0918C4.28271 11.6133 4.45133 11.2054 4.78857 10.8682C5.13037 10.5309 5.53825 10.3623 6.01221 10.3623C6.49072 10.3623 6.8986 10.5309 7.23584 10.8682C7.57764 11.2054 7.74854 11.6133 7.74854 12.0918C7.74854 12.5703 7.57764 12.9805 7.23584 13.3223C6.8986 13.6595 6.49072 13.8281 6.01221 13.8281C5.53825 13.8281 5.13037 13.6595 4.78857 13.3223C4.45133 12.9805 4.28271 12.5703 4.28271 12.0918ZM11.1909 12.0918C11.1909 11.6133 11.3595 11.2054 11.6968 10.8682C12.0386 10.5309 12.4465 10.3623 12.9204 10.3623C13.3989 10.3623 13.8068 10.5309 14.144 10.8682C14.4858 11.2054 14.6567 11.6133 14.6567 12.0918C14.6567 12.5703 14.4858 12.9805 14.144 13.3223C13.8068 13.6595 13.3989 13.8281 12.9204 13.8281C12.4465 13.8281 12.0386 13.6595 11.6968 13.3223C11.3595 12.9805 11.1909 12.5703 11.1909 12.0918ZM18.0991 12.0918C18.0991 11.6133 18.2677 11.2054 18.605 10.8682C18.9468 10.5309 19.3547 10.3623 19.8286 10.3623C20.3071 10.3623 20.715 10.5309 21.0522 10.8682C21.394 11.2054 21.5649 11.6133 21.5649 12.0918C21.5649 12.5703 21.394 12.9805 21.0522 13.3223C20.715 13.6595 20.3071 13.8281 19.8286 13.8281C19.3547 13.8281 18.9468 13.6595 18.605 13.3223C18.2677 12.9805 18.0991 12.5703 18.0991 12.0918Z",
    fill: "black",
    fillOpacity: 0.25
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1317_4250"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.399902)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDots);
export default __webpack_public_path__ + "static/media/three-dots.38a493261bf487b4614fca749c99497f.svg";
export { ForwardRef as ReactComponent };